import { Reference } from '@approvalmax/types';

import { DateRangeFilterRangeType } from '../../../../data/filters/dateRangeFilter';
import { messages } from './FilterDateRange.messages';

export const minCustomRangeDate = new Date('1753-01-01');
export const maxCustomRangeDate = new Date('9999-12-30');

export const optionsRangeType: Reference[] = [
    {
        id: DateRangeFilterRangeType.None,
        text: messages.rangeTypeTextNone,
    },
    {
        id: DateRangeFilterRangeType.Custom,
        text: messages.rangeTypeTextCustom,
    },
    {
        id: DateRangeFilterRangeType.Today,
        text: messages.rangeTypeTextToday,
    },
    {
        id: DateRangeFilterRangeType.Yesterday,
        text: messages.rangeTypeTextYesterday,
    },
    {
        id: DateRangeFilterRangeType.Tomorrow,
        text: messages.rangeTypeTextTomorrow,
    },
    {
        id: DateRangeFilterRangeType.ThisWeek,
        text: messages.rangeTypeTextThisWeek,
    },
    {
        id: DateRangeFilterRangeType.LastWeek,
        text: messages.rangeTypeTextLastWeek,
    },
    {
        id: DateRangeFilterRangeType.NextWeek,
        text: messages.rangeTypeTextNextWeek,
    },
    {
        id: DateRangeFilterRangeType.ThisMonth,
        text: messages.rangeTypeTextThisMonth,
    },
    {
        id: DateRangeFilterRangeType.LastMonth,
        text: messages.rangeTypeTextLastMonth,
    },
    {
        id: DateRangeFilterRangeType.NextMonth,
        text: messages.rangeTypeTextNextMonth,
    },
];
